import { FC } from 'react';

import { Control, Controller, FieldError } from 'react-hook-form';

import { IOTPInputProps } from '../OTPInput/types';

import { OTPInput } from '../OTPInput';

interface IControlledOTPInputProps extends Omit<IOTPInputProps, 'error'> {
  control: Control<any, any>;
  name: string;
  error?: FieldError;
}

export const ControlledOTPInput: FC<IControlledOTPInputProps> = ({
  control,
  name,
  error,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        return (
          <OTPInput
            {...props}
            value={value}
            error={error?.message || ''}
            onChange={onChange}
          />
        );
      }}
    />
  );
};
